import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../_helpers/axios_instance';

/**
 * Async Thunk for fetching stressor categories.
 * This handles the API call and dispatches pending/fulfilled/rejected actions.
 */
export const fetchStressorCategories = createAsyncThunk(
  'stressorCategories/fetchAll',
  async (_, { rejectWithValue }) => { // The first argument is for payload, but we don't need one here.
    try {
      const response = await axiosInstance.get('/api/static_comments/categories');
      // The returned data will become the payload of the `fulfilled` action
      return response.data;
    } catch (error) {
      // Use `rejectWithValue` to pass a specific error payload to the `rejected` action
      const errorPayload = error.response?.data?.errors || error.message;
      return rejectWithValue(errorPayload);
    }
  },
  {
    condition: (thunkArg, { getState }) => {
      const { stressor_categories } = getState();
      const { status } =  stressor_categories;
      return status !== 'loading';
    },
  }
);

/**
 * The initial state for this part of the Redux store.
 */
const initialState = {
  categories: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

/**
 * The slice definition, including the reducer logic.
 */
const stressorCategoriesSlice = createSlice({
  name: 'stressorCategories',
  initialState,
  // `reducers` is for synchronous actions, none needed here for now.
  reducers: {},
  // `extraReducers` handles the actions dispatched by our async thunk.
  extraReducers: (builder) => {
    builder
    .addCase(fetchStressorCategories.pending, (state) => {
      state.status = 'loading';
      state.error = null;
    })
    .addCase(fetchStressorCategories.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.categories = action.payload.sort((a, b) => a.name.localeCompare(b.name));
    })
    .addCase(fetchStressorCategories.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.payload;
    });
  },
});

// Export the reducer to be added to the main store
export default stressorCategoriesSlice.reducer;